// The Shift and the Secondary Shift use the same screens; this says which APIs and
// which user right each one uses.
export const SHIFT_TYPES = {
    primary: {
        key: 'primary',
        label: 'Shift',
        managementLabel: 'Shift Management',
        rightKey: 'ShiftMaster',
        masterApi: 'shift',
        getInstanceDocsApi: 'GetShiftInstanceDoc',
        updateInstanceApi: 'updateShiftInstance',
        deleteInstanceDocsApi: 'deleteShiftSettingDocs',
        managementApi: 'ShiftManagement',
    },
    secondary: {
        key: 'secondary',
        label: 'Secondary Shift',
        managementLabel: 'Secondary Shift Management',
        rightKey: 'SecondaryShiftMaster',
        masterApi: 'secondaryShift',
        getInstanceDocsApi: 'GetSecondaryShiftInstanceDoc',
        updateInstanceApi: 'updateSecondaryShiftInstance',
        deleteInstanceDocsApi: 'deleteSecondaryShiftSettingDocs',
        managementApi: 'SecondaryShiftManagement',
    },
};

export function getShiftType(key) {
    return SHIFT_TYPES[key] || SHIFT_TYPES.primary;
}

export function isSecondaryShiftEnabled(company) {
    return !!(company && company.allowSecondaryShift);
}

// Whether the user may `perType` ('read' | 'write' | 'update') on this shift type.
// The Secondary Shift also needs "Allow Secondary Shift" on in Company Settings.
export function canAccessShiftType(shiftType, perType, company, getRightsForAccess) {
    if (!getRightsForAccess) return false;
    if (shiftType.key === 'secondary' && !isSecondaryShiftEnabled(company)) return false;
    return !!getRightsForAccess('StaticDataRights', shiftType.rightKey, perType);
}

// The shift types this user can open, in tab order.
export function visibleShiftTypes(company, getRightsForAccess) {
    return Object.values(SHIFT_TYPES).filter(type => canAccessShiftType(type, 'read', company, getRightsForAccess));
}
